export function isNotExists<T>(input: T): input is Exclude<T, null | undefined | ''> {
  return !isExists(input);
}

export function isExists<T>(input: T): input is Exclude<T, null | undefined | ''> {
  return !isUndefined(input) && !isNull(input) && !isEmptyString(input);
}

export function isUndefined(input: any): input is undefined {
  return input === undefined;
}

export function isNull(input: any): input is null {
  return input === null;
}

export function isEmptyString(input: any): input is '' {
  return input === '';
}

export function stopEvent(event: Event) {
  if (!isExists(event)) {
    return;
  }
  if (event.stopImmediatePropagation) {
    event.stopImmediatePropagation();
  }
  event.preventDefault ? event.preventDefault() : (event.returnValue = false);
}

export function isHasLength(input: string | any[] | null | undefined): boolean {
  return isExists(input) && input!.length > 0;
}

export function clone<T>(source: T): T {
  const sourcePrototype = Object.getPrototypeOf(source);
  const clonedObj = Object.create(sourcePrototype);
  return Object.assign(clonedObj, source);
}
